var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgFavicon = function SvgFavicon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#favicon_svg__a)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.28
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.48 38.065c0-.914-.752-1.655-1.68-1.655-.928 0-1.68.74-1.68 1.655v8.28c0 .914.752 1.655 1.68 1.655.928 0 1.68-.741 1.68-1.655v-8.28z",
    fill: "#FF7304"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.48 38.065c0-.914-.752-1.655-1.68-1.655-.928 0-1.68.74-1.68 1.655v8.28c0 .914.752 1.655 1.68 1.655.928 0 1.68-.741 1.68-1.655v-8.28z",
    fill: "url(#favicon_svg__b)",
    fillOpacity: 0.19
  })), /*#__PURE__*/React.createElement("path", {
    d: "M21.48 44.69c0-.914-.752-1.655-1.68-1.655-.928 0-1.68.74-1.68 1.655v1.655c0 .914.752 1.655 1.68 1.655.928 0 1.68-.741 1.68-1.655V44.69z",
    fill: "#FF7304"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.48 44.69c0-.914-.752-1.655-1.68-1.655-.928 0-1.68.74-1.68 1.655v1.655c0 .914.752 1.655 1.68 1.655.928 0 1.68-.741 1.68-1.655V44.69z",
    fill: "url(#favicon_svg__c)",
    fillOpacity: 0.19
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.88 38.065c0-.914-.752-1.655-1.68-1.655-.928 0-1.68.74-1.68 1.655v8.28c0 .914.752 1.655 1.68 1.655.928 0 1.68-.741 1.68-1.655v-8.28z",
    fill: "#FF7304"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.88 38.065c0-.914-.752-1.655-1.68-1.655-.928 0-1.68.74-1.68 1.655v8.28c0 .914.752 1.655 1.68 1.655.928 0 1.68-.741 1.68-1.655v-8.28z",
    fill: "url(#favicon_svg__d)",
    fillOpacity: 0.19
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.813 1.24 3.307 33.102a2.171 2.171 0 0 0 .183 2.466c.279.346.656.6 1.083.732.427.132.885.133 1.313.005l17.01-6.405a3.723 3.723 0 0 1 2.21 0l17.01 6.405c.428.128.885.127 1.312-.005a2.23 2.23 0 0 0 1.083-.732 2.172 2.172 0 0 0 .183-2.466L26.19 1.24a2.502 2.502 0 0 0-.923-.916 2.549 2.549 0 0 0-2.53 0 2.5 2.5 0 0 0-.923.916z",
    fill: "#FF7304"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.813 1.24 3.307 33.102a2.171 2.171 0 0 0 .183 2.466c.279.346.656.6 1.083.732.427.132.885.133 1.313.005l17.01-6.405a3.723 3.723 0 0 1 2.21 0l17.01 6.405c.428.128.885.127 1.312-.005a2.23 2.23 0 0 0 1.083-.732 2.172 2.172 0 0 0 .183-2.466L26.19 1.24a2.502 2.502 0 0 0-.923-.916 2.549 2.549 0 0 0-2.53 0 2.5 2.5 0 0 0-.923.916z",
    fill: "url(#favicon_svg__e)",
    fillOpacity: 0.19
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "favicon_svg__b",
    x1: 19.8,
    y1: 36.41,
    x2: 19.8,
    y2: 48,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "favicon_svg__c",
    x1: 19.8,
    y1: 43.035,
    x2: 19.8,
    y2: 48,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "favicon_svg__d",
    x1: 28.2,
    y1: 36.41,
    x2: 28.2,
    y2: 48,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "favicon_svg__e",
    x1: 24.001,
    y1: -0.011,
    x2: 24.001,
    y2: 36.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "favicon_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(3)",
    d: "M0 0h42v48H0z"
  })))));
};

export default SvgFavicon;